import { formatDate } from 'utils/helpers/date'
import ActionCellRenderer from './actionCellRenderer'
import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'

export const FRESH_CATEGORY_UPLOAD_MODULE = 'FRESH_CATEGORY_IMAGE'

export const FRESH_CATEGORY_IMAGE_TYPES = ['.png', '.jpeg', '.jpg', '.webp']

export const freshCategoryFormFields = {
  NAME: { key: 'name', label: 'Category Name' },
  EXCLUDED_BARCODES: { key: 'excludedBarcodes', label: 'Excluded Barcodes' },
  IMAGE: { key: 'image', label: 'Category Image' },
  IS_ACTIVE: { key: 'isActive', label: 'Active' },
}

export const statusFilterOptions = [
  { label: 'All', value: 'NONE', disabled: false },
  { label: 'Active', value: 'true', disabled: false },
  { label: 'Inactive', value: 'false', disabled: false },
]

const { NAME, EXCLUDED_BARCODES, IS_ACTIVE } = freshCategoryFormFields

const listFormatter = (params: ValueFormatterParams) =>
  Array.isArray(params.value) && params.value.length
    ? params.value.join(', ')
    : '-'

export const getColumns = (
  isEditor: boolean,
  getCategoryToDelete: (params: ICellRendererParams) => void,
) =>
  [
    { headerName: NAME.label, field: NAME.key, minWidth: 200 },
    {
      headerName: EXCLUDED_BARCODES.label,
      field: EXCLUDED_BARCODES.key,
      minWidth: 200,
      valueFormatter: listFormatter,
    },
    {
      headerName: 'Status',
      field: IS_ACTIVE.key,
      cellRenderer: (params: ICellRendererParams) =>
        params?.value === true
          ? 'Active'
          : params?.value === false
            ? 'Inactive'
            : '-',
    },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'save',
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer
          params={params}
          isEditor={isEditor}
          getCategoryToDelete={getCategoryToDelete}
        />
      ),
    },
  ] as ColDef[]
